(() => {
  const roots = document.querySelectorAll(".stock-badge-root");
  if (!roots.length) return;

  const parseJSON = (str) => {
    try { return JSON.parse(str); } catch(e) { return {}; }
  };

  const findVariantIdInput = (root) => {
    const form = root.closest("form") || document.querySelector('form[action*="/cart/add"]');
    if (!form) return document.querySelector('[name="id"]');
    return form.querySelector('[name="id"]') || document.querySelector('[name="id"]');
  };

  const computeState = (data) => {
    if (!data) return "in";
    if (data.available === false) return "out";
    const managed = !!data.managed;
    const qty = Number(data.qty ?? 0);
    const threshold = Number(data.threshold ?? 20);
    if (managed && qty <= threshold) return "low";
    return "in";
  };

  roots.forEach((root) => {
    const badge = root.querySelector(".stock-badge");
    const dot = root.querySelector(".stock-badge__dot");
    const label = root.querySelector(".stock-badge__label");

    const variants = parseJSON(root.dataset.variants || "{}");
    const textIn = root.dataset.textIn || "Ce produit est en stock";
    const textLow = root.dataset.textLow || "Ce produit est bientôt en rupture";
    const textOut = root.dataset.textOut || "Ce produit est indisponible";
    const pulseEnabled = String(root.dataset.pulse) === "true";

    const setUI = (state) => {
      badge.classList.remove("stock-badge--in", "stock-badge--low", "stock-badge--out", "stock-badge--init");
      badge.classList.add(`stock-badge--${state}`);

      if (label) {
        label.textContent = state === "out" ? textOut : state === "low" ? textLow : textIn;
      }

      if (dot) {
        dot.classList.toggle("is-pulsing", pulseEnabled);
      }
    };

    const getCurrentVariantId = () => {
      const input = findVariantIdInput(root);
      return input?.value || root.dataset.initialVariantId;
    };

    const update = () => {
      const id = getCurrentVariantId();
      const data = variants[id];
      const state = computeState(data);
      setUI(state);
    };

    const bind = () => {
      const input = findVariantIdInput(root);
      if (input) {
        input.addEventListener("change", update);
        const mo = new MutationObserver(update);
        mo.observe(input, { attributes: true, attributeFilter: ["value"] });
      }
      document.addEventListener("variant:change", update);
      document.addEventListener("change", (e) => {
        if (e.target && e.target.name === "id") update();
      });
      window.addEventListener("load", update);
    };

    bind();
    update();
  });
})();
